import '/src/css/common.scss'
import '/src/components/atar-calculator/style.scss'
import '/src/components/course-list-by-atar/style.scss'

// register custom plugins
import customPersist from '/src/plugins/custom-persist'

document.addEventListener('alpine:init', () => {
  Alpine.plugin(customPersist)
})

import '/src/components/store/index.js'
import '/src/components/atar-calculator/index.js'
import '/src/components/course-list-by-atar/index.js'
